import { toast } from "react-toastify";

export const parseErrorMessage = (error: any) => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.errorMessage ||
    error?.response?.data?.error ||
    error?.response?.data ||
    "Something went wrong, please try again or contact support if error persists."
  );
};

export const errorToast = (error: any) => {
  toast.error(
    error?.response?.data?.message ||
      error?.response?.data?.errorMessage ||
      error?.response?.data?.error ||
      error?.response?.data ||
      "Something went wrong, please try again or contact support if error persists."
  );
};
